import { href, useNavigate } from 'react-router';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sessionQueries } from '~entities/session';
import { clearAllRevisions } from '~shared/api/revisionsKeys';
import { ROUTES } from '~shared/routes';

import { postLogin } from '../api';
import { pharmacyStorage } from '../lib/pharmacy-storage';
import { LoginFormData } from './login.schema';

export const usePostLogin = (pharmacyId: string) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: (formData: LoginFormData) => postLogin(pharmacyId, formData),
    // A revision left by a previous session makes the backend reject the login
    onMutate: () => clearAllRevisions(pharmacyId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: sessionQueries.all(pharmacyId),
      });

      pharmacyStorage.setLastPharmacyId(pharmacyId);

      navigate(href(ROUTES.dashboard, { pharmacyId }));
    },
  });

  return {
    login: mutation.mutate,
    reset: mutation.reset,
    isPending: mutation.isPending,
    isError: mutation.isError,
  };
};
